<article class="score-compare">
  <div class="score-compare__chart">
    <div class="score-compare__chart-header">
      <div>
        <h6>PEF Score Comparison</h6>
        <p>Chart of Alternative Product from lowest to highest PEF Score[Pt]</p>
      </div>
      <mds-button
        [isIconLeft]="false"
        [isIconRight]="true"
        [isLeftRightIconSame]="false"
        [iconRight]="icons.ARROW_FORWARD_LIGHT"
        [iconPathColors]="['#335568']"
        (click)="configureProductAlternatives()"
        [type]="'secondary'">
        Configure product alternatives
      </mds-button>
    </div>
    <div class="score-compare__chart-container">
      <ng-container>
        <ng-container>
          @if (!chartOptions) {
            <app-empty-chart [title]="emptyChart.title"
            [description]="emptyChart.description"></app-empty-chart>
          }
        </ng-container>
        <ng-container>
          <div class="score-chart-content" #chartContainer>
            @if (chartOptions) {
              <highcharts-chart class="chart-1" [Highcharts]="Highcharts" [options]="chartOptions"
                [oneToOne]="true">
              </highcharts-chart>
            }
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</article>

